import React, { useEffect, useState, useRef } from 'react';
interface ReasonCardProps {
  number: number;
  title: string;
  content: {
    paragraphs?: string[];
    bullets?: string[];
  };
  testimonial?: {
    text: string;
    author: string;
  };
  imageUrl: string;
  imageAlt: string;
}
export function ReasonCard({
  number,
  title,
  content,
  testimonial,
  imageUrl,
  imageAlt
}: ReasonCardProps) {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.2
    });
    if (cardRef.current) {
      observer.observe(cardRef.current);
    }
    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);
  return <div ref={cardRef} className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-329">
      <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300" data-id="element-330">
        <div className="grid md:grid-cols-2 gap-6 p-6 md:p-8 items-center" data-id="element-331">
          <div className="order-2 md:order-1" data-id="element-332">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-purple-600 text-white rounded-full text-xl font-bold mb-4" data-id="element-333">
              {number}
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-334">
              {title}
            </h3>

            {content.paragraphs && <div className="space-y-4 mb-4" data-id="element-335">
                {content.paragraphs.map((paragraph, index) => <p key={index} className="text-gray-700 text-base leading-relaxed" dangerouslySetInnerHTML={{
              __html: paragraph
            }} data-id="element-336" />)}
              </div>}

            {content.bullets && content.bullets.length > 0 && <div className="space-y-2 my-4" data-id="element-337">
                {content.bullets.map((bullet, index) => <div key={index} className="flex items-start gap-2" data-id="element-338">
                    <span className="text-green-600 font-bold text-lg flex-shrink-0 mt-0.5" data-id="element-339">
                      ✓
                    </span>
                    <span className="text-gray-700 text-base" dangerouslySetInnerHTML={{
                __html: bullet
              }} data-id="element-340" />
                  </div>)}
              </div>}
          </div>
          <div className="order-1 md:order-2" data-id="element-341">
            <img src={imageUrl} alt={imageAlt} className="w-full h-64 md:h-80 object-cover rounded-lg" data-id="element-342" />
          </div>
        </div>

        {testimonial && <div className="mx-6 md:mx-8 mb-6 md:mb-8 bg-purple-50 border-l-4 border-purple-600 rounded-lg p-4" data-id="element-343">
            <p className="text-gray-700 italic text-sm leading-relaxed mb-2" data-id="element-344">
              "{testimonial.text}"
            </p>
            <p className="text-gray-900 font-semibold text-sm" data-id="element-345">
              — {testimonial.author}
            </p>
          </div>}
      </div>
    </div>;
}